import { render, staticRenderFns } from "./ListStructuresPage.vue?vue&type=template&id=77a30a80"
import script from "./ListStructuresPage.vue?vue&type=script&lang=js"
export * from "./ListStructuresPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports